/**
 * refresh-report-schemas-request.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class RefreshReportSchemasRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_REFRESH_REPORT_SCHEMAS;
	public static tag : MessageTag = MessageTag.REQ_REFRESH_REPORT_SCHEMAS;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_REFRESH_REPORT_SCHEMAS);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/schemas/refresh-report-schemas-request.ts